import { styled } from '@mui/material';
export const RootHydrateFallbackRoot = styled('div')({
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
});
